// import Card from '../property-card'
import React, { useEffect } from "react"

import { Link, graphql, useStaticQuery } from "gatsby"

import { connect } from "react-redux"
import {
  getEnvironment,
  getTypes,
  getLocations,
  getServices,
  checkCurrentFilters,
  makeParamsGetByFilters,
  makeFormDataByFilters,
  makeParamsCoordinates,
  makeParamsByFiltersMediacore,
} from "../../helpers/helper.filters"
import useQueryProperties from "../../hooks/useQueryProperties"
import useQuerySummary from "../../hooks/useQuerySummary"

const ClientSideOnlyLazy = React.lazy(() => import("../property-card"))

const Results = ({
  filters,
  offset,
  orders,
  coordinates,
  polygonCoordinates,
}) => {
  const { realEstate } = useStaticQuery(graphql`
    query {
      realEstate {
        env {
          CLIENTID
        }
        keys {
          tokko
        }
      }
    }
  `)

  const { allSummaryData, isLoading: isLoadingAllTokkoFilters } =
    useQuerySummary()
  // // const { data: properties, isLoading: isLoadingProperties, isFetching: isFetchingProperties } = useGetPropertiesMediacoreQuery({"CLIENT_ID":realEstate.env.CLIENTID,"PARAMS":makeParamsByFiltersMediacore(filters)})
  const {
    properties,
    isLoading: isLoadingProperties,
    isFetching: isFetchingProperties,
  } = useQueryProperties({
    filters,
    coordinates,
    polygonCoordinates,
    orders,
    offset,
  })

  // const { data: properties, isLoading: isLoadingProperties, isFetching: isFetchingProperties } = useGetPropertiesQuery({
  //     "API_KEY":realEstate.keys.tokko,
  //     "params_get":makeParamsGetByFilters(orders,offset,polygonCoordinates) + makeFormDataByFilters(filters,coordinates,polygonCoordinates),
  //     "body":makeParamsCoordinates(coordinates,polygonCoordinates)
  //   });
  const isSSR = typeof window === "undefined"

  const MediaSeo = false

  useEffect(() => {
    scrollTo({ top: 0, behavior: "smooth" })
  }, [properties])

  const order_properties_mediacore = properties => {
    if (!realEstate.keys.tokko) {
      let properties_order = properties.map(prop => prop)
      switch (orders.order_by) {
        case "id": {
          let response = properties_order.sort((a, b) => a.id - b.id)
          if (orders.order === "desc") {
            response.reverse()
          }
          return response
        }
        case "price": {
          let response = properties_order.sort(
            (a, b) =>
              a.operations.find(
                op =>
                  op.operation_type?.toLowerCase() ===
                  filters.operation
                    ?.toLowerCase()
                    .replace("temporario", "alquiler temporario")
              )?.prices?.price -
              b.operations.find(
                op =>
                  op.operation_type?.toLowerCase() ===
                  filters.operation
                    ?.toLowerCase()
                    .replace("temporario", "alquiler temporario")
              )?.prices?.price
          )
          if (orders.order === "desc") {
            response.reverse()
          }
          return response
        }
        case "total_surface": {
          let response = properties_order.map(prop => ({
            ...prop,
            surface_to_filter:
              prop.type.name === "Campo" || prop.type.name === "Terreno"
                ? prop.surface
                : prop.total_surface,
          }))
          console.log(response)
          response = response.sort(
            (a, b) => a.surface_to_filter - b.surface_to_filter
          )
          if (orders.order === "desc") {
            response.reverse()
          }
          return response
        }
        default:
          return properties
      }
    }
    return properties
  }

  return (
    <>
      <section id="results" className="col-lg-12 mt-5">
        <div className="row gx-lg-5 list d-flex justify-content-start ">
          <div
            className={
              "col-12" +
              (properties?.objects?.length === 0 && !isLoadingProperties
                ? ""
                : " d-none")
            }
          >
            <div class={"alert alert-info "}>
              No se encontraron resultados para su búsqueda.
            </div>
          </div>
          {isLoadingProperties || isFetchingProperties
            ? [1, 2, 3, 4, 5, 6].map((element, index) => (
                <div className="col-lg-4">
                  {!isSSR && (
                    <React.Suspense fallback={<div />}>
                      <ClientSideOnlyLazy key={index} skeleton={true} />
                    </React.Suspense>
                  )}
                </div>
              ))
            : order_properties_mediacore(properties?.objects)?.map(
                (item, index) => (
                  <div className="col-lg-4">
                    {!isSSR && (
                      <React.Suspense fallback={<div />}>
                        <ClientSideOnlyLazy key={index} property={item} />
                      </React.Suspense>
                    )}
                  </div>
                )
              )}
        </div>
        <div
          className={"seo-section mt-5 pt-lg-5 " + (MediaSeo ? "" : "d-none")}
        >
          <div className="item">
            <h2>PROPIEDADES EN VENTA POR UBICACIÓN</h2>
            <div className="row">
              <div className="col-lg-10 col-xl-9 d-flex flex-wrap">
                {allSummaryData
                  ? getLocations(allSummaryData?.objects).map((item, index) => (
                      <Link
                        to={item.location_name.toLowerCase().replace(/ /g, "-")}
                      >
                        <p
                          key={index}
                          className={
                            "tag-filter-button tag-button " +
                            (checkCurrentFilters(
                              filters,
                              "location",
                              item.location_name
                            )
                              ? "active"
                              : "")
                          }
                        >
                          {item.location_name}
                        </p>
                      </Link>
                    ))
                  : ""}
              </div>
            </div>
          </div>
          <div className="item">
            <h2>TIPO DE PROPIEDADES EN VENTA</h2>
            <div className="row">
              <div className="col-lg-8 d-flex flex-wrap">
                {allSummaryData
                  ? getTypes(allSummaryData?.objects).map((item, index) => (
                      <Link to={item.type.toLowerCase().replace(/ /g, "-")}>
                        <p
                          key={index}
                          className={
                            "tag-filter-button tag-button " +
                            (checkCurrentFilters(filters, "type", item.type)
                              ? "active"
                              : "")
                          }
                        >
                          {item.type}
                        </p>
                      </Link>
                    ))
                  : ""}
              </div>
            </div>
          </div>
          <div className="item">
            <h2>PROPIEDADES EN VENTA POR AMBIENTES</h2>
            <div className="row">
              <div className="col-lg-8 d-flex flex-wrap">
                <Link to={"1-ambiente"}>
                  <p
                    className={
                      "tag-filter-button tag-button " +
                      (checkCurrentFilters(
                        filters,
                        "environments",
                        "1 Ambiente"
                      )
                        ? "active"
                        : "")
                    }
                  >
                    1 Ambiente
                  </p>
                </Link>
                <Link to={"2-ambientes"}>
                  <p
                    className={
                      "tag-filter-button tag-button " +
                      (checkCurrentFilters(
                        filters,
                        "environments",
                        "2 Ambientes"
                      )
                        ? "active"
                        : "")
                    }
                  >
                    2 Ambientes
                  </p>
                </Link>
                <Link to={"3-ambientes"}>
                  <p
                    className={
                      "tag-filter-button tag-button " +
                      (checkCurrentFilters(
                        filters,
                        "environments",
                        "3 Ambientes"
                      )
                        ? "active"
                        : "")
                    }
                  >
                    3 Ambientes
                  </p>
                </Link>
                <Link to={"4-ambientes"}>
                  <p
                    className={
                      "tag-filter-button tag-button " +
                      (checkCurrentFilters(
                        filters,
                        "environments",
                        "4 Ambientes"
                      )
                        ? "active"
                        : "")
                    }
                  >
                    4 Ambientes
                  </p>
                </Link>
                <Link to={"5-ambientes"}>
                  <p
                    className={
                      "tag-filter-button tag-button " +
                      (checkCurrentFilters(
                        filters,
                        "environments",
                        "5 Ambientes"
                      )
                        ? "active"
                        : "")
                    }
                  >
                    5 Ambientes
                  </p>
                </Link>
              </div>
            </div>
          </div>
          <div className="item">
            <h2>PROPIEDADES EN VENTA POR TIPO DE AMBIENTES</h2>
            <div className="row">
              <div className="col-lg-8 d-flex flex-wrap">
                {allSummaryData
                  ? getEnvironment(allSummaryData?.objects).map(
                      (item, index) => (
                        <Link
                          to={item.tag_name.toLowerCase().replace(/ /g, "-")}
                        >
                          <p
                            key={index}
                            className={
                              "tag-filter-button tag-button " +
                              (checkCurrentFilters(
                                filters,
                                "environments_types",
                                { id: item.tag_id, name: item.tag_name }
                              )
                                ? "active"
                                : "")
                            }
                          >
                            {item.tag_name}
                          </p>
                        </Link>
                      )
                    )
                  : ""}
                {/* <p className="tag-filter-button">FILTER</p> */}
              </div>
            </div>
          </div>
          <div className="item">
            <h2>PROPIEDADES EN VENTA POR SERVICIOS</h2>
            <div className="row">
              <div className="col-lg-8 d-flex flex-wrap">
                {allSummaryData
                  ? getServices(allSummaryData?.objects).map((item, index) => (
                      <Link to={item.tag_name.toLowerCase().replace(/ /g, "-")}>
                        <p
                          key={index}
                          className={
                            "tag-filter-button tag-button " +
                            (checkCurrentFilters(filters, "services", {
                              id: item.tag_id,
                              name: item.tag_name,
                            })
                              ? "active"
                              : "")
                          }
                        >
                          {item.tag_name}
                        </p>
                      </Link>
                    ))
                  : ""}
                {/* <p className="tag-filter-button">FILTER</p> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default connect(
  state => ({
    properties: state.properties.properties,
    totalCount: state.properties.totalCount,
    filters: state.properties.filters,
    totalListFilters: state.properties.totalListFilters,
    loading: state.properties.loading,
    loading_more: state.properties.loading_more,
    offset: state.properties.offset,
    orders: state.properties.orders,
    coordinates: state.properties.coordinates,
    polygonCoordinates: state.properties.polygonCoordinates,
  }),
  null
)(Results)
